const translation = {
    PageSize: 'Page Size',
    PageOrientation: 'Page Orientation',
    Format: 'Format',
    DPI: 'DPI',
    Title: 'Export map',
    Close: 'Close',
    Save: 'Save',
    FileName: 'File name',
    Landscape: 'Landscape',
    Portrait: 'Portrait',
    PreviewHint: 'Adjust the area to export on the map.',
    ExportFailed: 'Failed to export the map. Please try again.',
    PreviewFailed: 'Failed to render the preview.',
    AdjustArea: 'Adjust area on map',
    AdjustAreaHint: 'Move, zoom, rotate or tilt the map to frame the area to export',
    ZoomIn: 'Zoom in',
    ZoomOut: 'Zoom out',
    ResetZoom: 'Reset zoom to 100%',
    Done: 'Done',
    Cancel: 'Cancel',
    Scalebar: 'Scale bar',
    NorthIcon: 'North icon',
    ChooseNorthIcon: 'Choose the north icon',
    ChooseSvgFile: 'Choose an SVG file',
    IconSymbol: 'Icon symbol',
    IconColor: 'Icon color',
    IconSize: 'Icon size',
    InvalidSvg: 'The file is not a valid SVG.',
    ExportAsVector: 'Export as vector',
    ExportLabelsAsVector: 'Export labels as vector',
    Custom: 'Custom',
    Width: 'Width',
    Height: 'Height',
    LanguageName: 'English',
    LanguageCode: 'en'
};
export default translation;
